<mat-toolbar color="primary" class="app-header" [class.customer-service-disabled]="showCustomerServiceDisabledWarning">
  <a class="brand-link" routerLink="/" matTooltip="Zur Startseite" aria-label="Zur Startseite">
    <img class="logo" src="assets/Jugendlogo_Baum_Wappen.png" alt="Logo"/>
    <div class="title-block">
      <span class="title-text">{{ title }}</span>
      @if (cbActionYear) {
        <span class="title-year">{{ cbActionYear }}</span>
      }
    </div>
  </a>
  <span class="spacer"></span>

  <div class="desktop-actions">
    @if (customerServiceEnabled && !isTeamboardOnly) {
      <button mat-icon-button class="order-tree-button" (click)="openOrderDialog()" matTooltip="Baum bestellen"
              aria-label="Baum bestellen">
        <mat-icon svgIcon="tree-circle-plus"></mat-icon>
      </button>
    }
    @if (hasMultipleDashboardRoles) {
      <button mat-icon-button routerLink="/" [queryParams]="{pickRole: 1}" matTooltip="Dashboard-Auswahl"
              aria-label="Dashboard-Auswahl">
        <mat-icon svgIcon="chart-simple"></mat-icon>
      </button>
    }
    @if (showAdminMenu) {
      <button mat-icon-button [matMenuTriggerFor]="adminMenu" matTooltip="Admin" aria-label="Admin">
        <mat-icon svgIcon="gears"></mat-icon>
      </button>
    }
    @if (isStaff) {
      <button mat-icon-button (click)="openStaffMessagesDialog()" matTooltip="Kundennachrichten"
              aria-label="Kundennachrichten"
              [matBadge]="unreadCount()" [matBadgeHidden]="unreadCount() === 0" matBadgeColor="warn" matBadgeSize="small">
        <mat-icon svgIcon="messages"></mat-icon>
      </button>
    }
    @if (isLoggedIn && !isTeamboardOnly && !isCustomerOnly) {
      <button mat-icon-button (click)="openPushSettingsDialog()" matTooltip="Benachrichtigungen" aria-label="Benachrichtigungen">
        <mat-icon svgIcon="bell"></mat-icon>
      </button>
    }
    @if (canUseMfa) {
      <button mat-icon-button (click)="openMfaSettingsDialog()" matTooltip="Zwei-Faktor-Authentisierung"
              aria-label="Zwei-Faktor-Authentisierung">
        <mat-icon svgIcon="lock-keyhole"></mat-icon>
      </button>
    }
    @if (isLoggedIn) {
      @if (showMyOrdersMenuItem && !isTeamboardOnly) {
        <button mat-icon-button (click)="openMyOrdersDialog()" matTooltip="Meine Aufträge" aria-label="Meine Aufträge">
          <mat-icon svgIcon="file-invoice"></mat-icon>
        </button>
      }
      <button mat-icon-button (click)="logout()" matTooltip="Log out" aria-label="Log out">
        <mat-icon svgIcon="right-from-bracket"></mat-icon>
      </button>
    } @else {
      <button mat-icon-button (click)="openLoginDialog()" matTooltip="Log in" aria-label="Log in">
        <mat-icon svgIcon="right-to-bracket"></mat-icon>
      </button>
    }
  </div>

  <button class="mobile-menu-trigger" mat-icon-button [matMenuTriggerFor]="mobileMenu" aria-label="Menu">
    <mat-icon svgIcon="bars"></mat-icon>
  </button>

  <mat-menu #adminMenu="matMenu">
    @if (canViewUsers) {
      <button mat-menu-item routerLink="/admin/users">Userverwaltung</button>
    }
    @if (canManageServiceConfigurations) {
      <button mat-menu-item (click)="openManageServiceConfigurationsDialog()">Services</button>
    }
    @if (canManagePickupDates) {
      <button mat-menu-item routerLink="/admin/pickup-dates">Abholtermine</button>
    }
    @if (isAdmin) {
      @if (canViewUsers || canManageServiceConfigurations || canManagePickupDates) {
        <mat-divider></mat-divider>
      }
      <button mat-menu-item routerLink="/admin/engines">Fahrzeuge</button>
      <button mat-menu-item routerLink="/admin/collecting-locations">Orte</button>
      <button mat-menu-item routerLink="/admin/streets">Straßen</button>
      <button mat-menu-item routerLink="/admin/collecting-zones">Zonen</button>
      <button mat-menu-item routerLink="/admin/collecting-areas">Bereiche</button>
      <button mat-menu-item routerLink="/admin/messages">Nachrichten</button>
    }
    @if (canManageRouteIcons) {
      @if (isAdmin || canViewUsers || canManageServiceConfigurations || canManagePickupDates) {
        <mat-divider></mat-divider>
      }
      <button mat-menu-item (click)="openRouteIconMappingsDialog()">Icons-Livekarte</button>
    }
  </mat-menu>

  <mat-menu #mobileMenu="matMenu" class="mobile-menu-panel">
    @if (customerServiceEnabled && !isTeamboardOnly) {
      <button mat-menu-item (click)="openOrderDialog()">
        <mat-icon svgIcon="tree-circle-plus"></mat-icon>
        <span>Baum bestellen</span>
      </button>
      <mat-divider></mat-divider>
    }
    @if (hasMultipleDashboardRoles) {
      <button mat-menu-item routerLink="/" [queryParams]="{pickRole: 1}">
        <mat-icon svgIcon="chart-simple"></mat-icon>
        <span>Dashboard-Auswahl</span>
      </button>
    }
    @if (showAdminMenu) {
      <button mat-menu-item [matMenuTriggerFor]="adminMenu">
        <mat-icon svgIcon="gears"></mat-icon>
        <span>Admin</span>
      </button>
      <mat-divider></mat-divider>
    }
    @if (isStaff) {
      <button mat-menu-item (click)="openStaffMessagesDialog()">
        <mat-icon svgIcon="messages"></mat-icon>
        <span>Kundennachrichten@if (unreadCount() > 0) { ({{ unreadCount() }} ungelesen)}</span>
      </button>
    }
    @if (isLoggedIn && !isTeamboardOnly && !isCustomerOnly) {
      <button mat-menu-item (click)="openPushSettingsDialog()">
        <mat-icon svgIcon="bell"></mat-icon>
        <span>Benachrichtigungen</span>
      </button>
    }
    @if (canUseMfa) {
      <button mat-menu-item (click)="openMfaSettingsDialog()">
        <mat-icon svgIcon="lock-keyhole"></mat-icon>
        <span>Zwei-Faktor-Authentisierung</span>
      </button>
    }
    @if (isLoggedIn) {
      @if (showMyOrdersMenuItem && !isTeamboardOnly) {
        <button mat-menu-item (click)="openMyOrdersDialog()">
          <mat-icon svgIcon="file-invoice"></mat-icon>
          <span>Meine Aufträge</span>
        </button>
      }
      <button mat-menu-item (click)="logout()">
        <mat-icon svgIcon="right-from-bracket"></mat-icon>
        <span>Log out</span>
      </button>
    } @else {
      <button mat-menu-item (click)="openLoginDialog()">
        <mat-icon svgIcon="right-to-bracket"></mat-icon>
        <span>Log in</span>
      </button>
    }
  </mat-menu>
</mat-toolbar>

<div class="app-body">
  <router-outlet></router-outlet>
</div>

<mat-toolbar color="primary" class="app-footer" [class.customer-service-disabled]="showCustomerServiceDisabledWarning">
  <span class="copyright-info" [matTooltip]="copyrightTooltip" matTooltipClass="multiline-tooltip">
    <mat-icon class="copyright-icon" aria-hidden="false" aria-label="Copyright" svgIcon="copyright"></mat-icon>
    <span>2026 by Tuckisoft</span>
  </span>
  <span class="app-version" [matTooltip]="'Backend Version: ' + backendVersion"
        [matTooltipDisabled]="!backendVersion">Version {{ appVersion }}</span>
  <span class="spacer"></span>
  @if (isLoggedIn) {
    <span [matTooltip]="currentUserRolesTooltip" matTooltipClass="roles-tooltip">
      {{ currentUserName }}
      @if (currentUserEmail) {
        <span class="user-email"> ({{ currentUserEmail }})</span>
      }
    </span>
    @if (currentUserRoleIcon; as roleIcon) {
      <mat-icon class="role-indicator-icon" [matTooltip]="currentUserRolesTooltip"
                matTooltipClass="roles-tooltip" [svgIcon]="roleIcon"></mat-icon>
    }
  }
</mat-toolbar>
